import React, { useCallback, useEffect, useRef, useState } from 'react';
import config from './config.json';
import { Modal, message, Popconfirm } from 'antd';
import { modalAddOrEditFn } from './components/addOrEdit';
import { SActionBtn, SBack, SLowcodeList, STableActions } from 'shj-components'
import { ExclamationCircleFilled } from '@ant-design/icons';
import { deleteCalculationFormula, checkCalculationFormula, calculationFormulaList } from '@/services/integrationConfig'
const { confirm } = Modal;
export default function () {
  const listRef = useRef<any>();
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        let data = await calculationFormulaList(current, pageSize, rest.query);
        resolve(data);
      } catch (e) {
        reject({ success: false });
      }
    });
  };
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  // 新增
  const add = (obj = {}) => {
    const {
      current: { reload },
    } = listRef;
    modalAddOrEditFn({
      fn: () => {
        reload();
      },
      ...obj,
    });
  };
  const edit = (obj: object) => {
    add(obj);
  };

  const onSave = useCallback((values, dialogDestroy) => { }, []);

  const onAdd = useCallback(() => {
    add();
  }, [onSave]);

  const onEdit = useCallback(
    (record) => {
      checkCalculationFormula({
        id: record.id,
      }).then((res: any) => {
        if (!res) {
          edit(record);
        }else{
          confirm({
            title: res,
            icon: <ExclamationCircleFilled />,
            onOk() {
              edit(record);
            },
            onCancel() {
              console.log('Cancel');
            },
          });
        }
      })
    },
    [onSave],
  );
  const onDel = useCallback(
    (record) => {
      deleteCalculationFormula(record.id).then((res: any) => {
        message.success('删除成功!');
        reloadFn();
      });
    },
    [onSave],
  );

  const extension = {
    request: { fetchList },
    events: { onAdd },
    customRender: {
      // 渲染操作栏
      renderOperate(text: string, record: object) {
        return (
          <div className="actionBox">
            <STableActions>
              <SActionBtn onClick={() => onEdit(record)}>
                编辑
              </SActionBtn>
              <SActionBtn title="是否删除？" danger confirm
                onClick={() => onDel(record)} okText="是" cancelText="否">删除</SActionBtn>
            </STableActions>
          </div>
        );
      },
    },
  };

  return <><SBack title={`表达式管理库`}></SBack><SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" /></>
}
